// extracted by mini-css-extract-plugin
export default {"section1":"Section1_section1__rE19s"};